import { useRef } from 'react';

const useDragColumnChange = (callback) => {
  const columnOrderRef = useRef([]);

  const onDragStarted = (evt) => {
    columnOrderRef.current = evt.api.getColumnState().map((c) => c.colId);
  };

  const onDragStopped = (evt) => {
    const newColumnOrder = evt.api.getColumnState().map((c) => c.colId);
    const sameOrder = columnOrderRef.current.every((c, i) => c === newColumnOrder[i]);

    if (!sameOrder && callback) {
      callback(newColumnOrder);
    }
  };

  return { onDragStarted, onDragStopped };
};

export { useDragColumnChange };
